

<div class="header_search m-t">
  <div class="title-page">
    <h3>Aditivos</h3>
  </div>
  <div class="content_search">
    <div class="new-project">
      <button class="btn btn-primary" type="btn" *ngIf="canSave" (click)="novo()">Novo</button>
    </div>
  </div>
</div>

<div class="system-table table-container">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th>Tipo de aditivo</th>
          <th>Data de término da vigência</th>
          <th>Valor de repasse</th>
          <th>Valor de contrapartida</th>
          <th class="text-center btn-icon-td">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let item of list">
          <tr>
            <td class="title">{{ item.additive_type_label }}</td>
            <td>{{ item.dt_end }}</td>
            <td>{{ item.transfer_value }}</td>
            <td>{{ item.counterpart_value }}</td>
            <td>
              <div class="btn-icon" *ngIf="canSave">
                <span class="icon-table" (click)="editar(item)">
                  <img src="assets/images/svgs/editar1.svg" alt="Editar" tooltip="Editar" placement="bottom">
                </span>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="!list?.length" class="border-b-radius">
          <td colspan="5" class="text-center">Nenhum Aditivo Cadastrado.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
